import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../configs';
import PersonView from './PersonView';
import JuridicalView from './JuridicalView';
import IndividualEntrepreneurView from './IndividualEntrepreneurView';
import { dateFormatter, infoFormatterIntl, localeFormatter } from '../../../../utils/formatters';
import FileView from '../../../../components/fields/FileInput/FileView';

export default function ApplicantView(props) {
  const {
    currentApplication = {}, fieldsValidation, isPreview,
  } = props;
  const { procedure, applicant = {} } = currentApplication;
  const { application_carrier = {}, files = [] } = currentApplication;

  let {
    legal_entity_type,
  } = applicant;

  const {
    logo_files,
    commercial_name,
    office_phone,
    office_email,
    office_name,
    office_address,
    office_legal_address,
  } = applicant;
  const {
    driver_license_series,
    driver_license_number,
    driver_license_issue_date,
    driver_license_expiration_date,
  } = application_carrier || {};

  if (typeof legal_entity_type === 'string') {
    legal_entity_type = Number(legal_entity_type);
  }

  const criminal_record_certificate_info_doc = files && files.length ? files.find(item => item.collection_name === 'criminal_record_certificate_info_doc') : undefined;
  return (
    <>
      {[USER_TYPE.PRIVATE_PERSON, USER_TYPE.PRIVATE_PERSON_OLD].includes(legal_entity_type) ? <PersonView isPreview={isPreview} fieldsValidation={fieldsValidation} applicant={applicant} files={files} prefix="applicant." /> : null}
      {legal_entity_type === USER_TYPE.LEGAL ? <JuridicalView fieldsValidation={fieldsValidation} isPreview={isPreview} applicant={applicant} prefix="applicant." /> : null}
      {legal_entity_type === USER_TYPE.INDIVIDUAL_ENTREPRENEUR ? <IndividualEntrepreneurView isPreview={isPreview} fieldsValidation={fieldsValidation} applicant={applicant} prefix="applicant." /> : null}
      {[USER_TYPE.LEGAL, USER_TYPE.INDIVIDUAL_ENTREPRENEUR].includes(legal_entity_type) && !isPreview ? (
        <Row className="row-cols-2">
          {infoFormatterIntl('commercial_name', commercial_name, fieldsValidation, 'applicant.commercial_name')}
          {infoFormatterIntl('logo_files', logo_files, fieldsValidation, 'applicant.logo_files')}
        </Row>
      ) : null}
      {[USER_TYPE.PRIVATE_PERSON_OLD, USER_TYPE.PRIVATE_PERSON].includes(legal_entity_type) && (procedure === PROCEDURE_TYPE.PROCEDURE_1227_1)
        ? (
          <>
            <div className="f4 mt-3">Водительское удостоверение</div>
            <Row className="row-cols-2">
              {infoFormatterIntl('driver_license_series', driver_license_series, fieldsValidation, 'application_carrier.driver_license_series')}
              {infoFormatterIntl('driver_license_number', driver_license_number, fieldsValidation, 'application_carrier.driver_license_number')}
            </Row>
            <Row className="row-cols-2">
              {infoFormatterIntl('driver_license_issue_date', dateFormatter(driver_license_issue_date), fieldsValidation, 'application_carrier.driver_license_issue_date')}
              {infoFormatterIntl('driver_license_expiration_date', dateFormatter(driver_license_expiration_date), fieldsValidation, 'application_carrier.driver_license_expiration_date')}
            </Row>
            <div className="f4 mt-3">Справка о наличии судимости</div>
            <Row className="row-cols-1">
              {infoFormatterIntl('media.criminal_record_certificate_info_doc', criminal_record_certificate_info_doc ? <FileView readOnly withoutMime withoutHr files={[criminal_record_certificate_info_doc]} /> : null, {}, '', 4)}
            </Row>
          </>
        ) : null}
      {[PROCEDURE_TYPE.PROCEDURE_1228_1].includes(procedure) && legal_entity_type === USER_TYPE.LEGAL
        ? (
          <>
            <div className="f4 mt-3">Филиал (представительство) в Санкт-Петербурге</div>
            <Row className="row-cols-1">
              {infoFormatterIntl('sp.office_name', office_name, fieldsValidation, 'applicant.office_address')}
            </Row>
            <Row className="row-cols-1">
              {infoFormatterIntl('sp.office_address_legal', office_legal_address, fieldsValidation, 'applicant.office_address_legal')}
            </Row>
            <Row className="row-cols-1">
              {infoFormatterIntl('sp.office_address', office_address, fieldsValidation, 'applicant.office_address')}
            </Row>
            <Row className="row-cols-1">
              {infoFormatterIntl('sp.office_phone', office_phone, fieldsValidation, 'applicant.office_phone')}
            </Row>
            <Row className="row-cols-1">
              {infoFormatterIntl('sp.office_email', office_email, fieldsValidation, 'applicant.office_email')}
            </Row>
          </>
        ) : null}
    </>
  );
}
